(function () {
  'use strict';

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function animate(el, keyframes, options) {
    if (!el || reducedMotion) return null;
    if (typeof el.animate === 'function') return el.animate(keyframes, options);
    return null;
  }

  function initReveal() {
    var nodes = document.querySelectorAll('[data-mb-reveal]');
    if (!nodes.length) return;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (node) { node.classList.add('is-revealed'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    nodes.forEach(function (node) { observer.observe(node); });
  }

  function initPressFeedback() {
    document.addEventListener('pointerdown', function (event) {
      var target = event.target.closest('[data-mb-press], .mb-btn, .mb-discover__chip, .mirabase-filter-pill, .mirabase-filter-chip, .mb-icon-btn, .mb-select-menu__trigger, .mb-select-menu__option');
      if (!target || target.disabled) return;
      target.classList.add('is-pressed');
    }, { passive: true });

    function clearPress(event) {
      var target = event.target.closest('.is-pressed');
      if (target) target.classList.remove('is-pressed');
    }
    document.addEventListener('pointerup', clearPress, { passive: true });
    document.addEventListener('pointercancel', clearPress, { passive: true });
  }

  function initFilterPills(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-mirabase-filter-group]').forEach(function (group) {
      if (group.dataset.mbFilterReady === '1') return;
      group.dataset.mbFilterReady = '1';

      var collection = group.closest('.mirabase-collection') || group;
      var cards = Array.prototype.slice.call(collection.querySelectorAll('[data-mirabase-product-card]'));
      var pills = Array.prototype.slice.call(group.querySelectorAll('.mirabase-filter-pill[data-mirabase-filter], .mb-scenarios__chip[data-mirabase-filter]'));
      var selects = Array.prototype.slice.call(group.querySelectorAll('[data-mirabase-filter]')).filter(function (el) {
        return el.tagName === 'SELECT';
      });
      var count = group.querySelector('[data-mirabase-filter-count]');
      var empty = group.querySelector('[data-mirabase-empty]');
      var clear = group.querySelector('[data-mirabase-filter-clear]');
      if (!pills.length && !selects.length) return;

      var isScenarios = Boolean(group.hasAttribute('data-mb-scenarios') || collection.classList.contains('mb-scenarios'));
      var defaultScene = normalizeTag(group.dataset.mbSceneDefault || (isScenarios ? 'dawn' : 'all'));
      var isHighlights = Boolean(group.hasAttribute('data-mb-highlights') || collection.classList.contains('mb-catalog--highlights'));
      var catalogTag = normalizeTag(group.dataset.mbCatalogTag || '');
      var state = { scene: isScenarios ? defaultScene : 'all', category: 'all', concern: 'all', highlight: 'all', sort: 'featured' };
      var sceneAliases = {
        dawn: ['down', 'dawn', 'morning'],
        down: ['down', 'dawn', 'morning'],
        sun: ['sun', 'noon', 'midday'],
        dusk: ['dusk', 'evening'],
        moon: ['moon', 'night'],
        bts: ['bts'],
        date: ['date'],
        beach: ['beach'],
        holiday: ['holiday'],
        mountain: ['mountain'],
        'shower-spa': ['shower', 'shower-spa', 'spa', 'shower_spa'],
        shower: ['shower', 'shower-spa', 'spa', 'shower_spa']
      };
      var grid = collection.querySelector('[data-mirabase-product-grid]');
      var sortSelect = group.querySelector('[data-mb-scenario-sort]');
      var titleEl = group.querySelector('[data-mb-scenario-title]');
      var ledeEl = group.querySelector('[data-mb-scenario-lede]');
      var ledeMoreEl = group.querySelector('[data-mb-scenario-lede-more]');
      var titleEnEl = group.querySelector('[data-mb-scenario-title-en]');
      var titleThEl = group.querySelector('[data-mb-scenario-title-th]');
      var ledeEnEl = group.querySelector('[data-mb-scenario-lede-en]');
      var ledeThEl = group.querySelector('[data-mb-scenario-lede-th]');
      var bannerEl = group.querySelector('[data-mb-scenario-banner]');

      function resolveSceneValue(raw) {
        var key = normalizeTag(raw);
        if (!key) return defaultScene;
        if (key === 'down' || key === 'morning') return 'dawn';
        if (key === 'shower' || key === 'shower_spa' || key === 'showerspa' || key === 'spa') return 'shower-spa';
        return key;
      }

      function cardTokens(card) {
        var tokens = String(card.dataset.tags || '')
          .split(',')
          .map(normalizeTag)
          .filter(Boolean);
        var scene = normalizeTag(card.dataset.scene);
        if (scene) tokens.push(scene);
        return tokens;
      }

      function matchesScene(card, selected) {
        if (!selected || selected === 'all') return true;
        var aliases = sceneAliases[selected] || [selected];
        var tokens = cardTokens(card);
        var category = normalizeTag(card.dataset.category || '');
        if (category) tokens.push(category);
        return aliases.some(function (alias) {
          return tokens.indexOf(normalizeTag(alias)) !== -1;
        });
      }

      function matchesHighlight(card, selected) {
        if (!selected || selected === 'all') return true;
        var tokens = cardTokens(card);
        if (selected === 'new-best') {
          return tokens.some(function (token) {
            return token === 'new-best' || token === 'newbest' || token === 'new-and-best';
          });
        }
        if (selected === 'best-seller') {
          return tokens.some(function (token) {
            return token === 'best-seller' || token === 'bestseller' || token === 'best-sellers' || token === 'best seller';
          });
        }
        if (selected === 'new') {
          return tokens.some(function (token) {
            return token === 'new' || token === 'new-product' || token === 'new-arrival' || token === 'core-2026' || token === 'new-arrivals';
          });
        }
        return true;
      }

      function matchesCatalogTag(card, selected) {
        if (!selected) return true;
        var tokens = cardTokens(card);
        var aliases = {
          'new-best': ['new-best', 'newbest', 'new-and-best', 'new-best-seller', 'new-best-sellers'],
          fragrance: ['fragrance', 'perfume'],
          makeup: ['makeup', 'make-up'],
          skincare: ['skincare', 'skin-care'],
          'body-hair': ['body-hair', 'body-and-hair', 'bath-hair'],
          sun: ['sun']
        };
        var list = aliases[selected] || [selected];
        return list.some(function (alias) {
          return tokens.indexOf(normalizeTag(alias)) !== -1;
        });
      }

      function syncUrl() {
        try {
          var url = new URL(window.location.href);
          if (state.scene && state.scene !== 'all') url.searchParams.set('scene', state.scene);
          else url.searchParams.delete('scene');
          if (state.category && state.category !== 'all') url.searchParams.set('category', state.category);
          else url.searchParams.delete('category');
          if (state.highlight && state.highlight !== 'all') url.searchParams.set('highlight', state.highlight);
          else url.searchParams.delete('highlight');
          if (state.sort && state.sort !== 'featured') url.searchParams.set('sort', state.sort);
          else url.searchParams.delete('sort');
          window.history.replaceState({}, '', url.pathname + url.search + url.hash);
        } catch (err) {}
      }

      function updateScenarioChrome(value) {
        var active = pills.filter(function (pill) {
          return pill.dataset.mirabaseFilter === 'scene' && resolveSceneValue(pill.dataset.value) === value;
        })[0];
        if (!active) return;
        if (titleEl) titleEl.textContent = active.dataset.title || active.dataset.titleEn || '';
        if (ledeEl) ledeEl.textContent = active.dataset.lede || '';
        if (ledeMoreEl) {
          var more = active.dataset.ledeMore || '';
          ledeMoreEl.textContent = more;
          ledeMoreEl.hidden = !more;
        }
        if (titleEnEl) titleEnEl.textContent = active.dataset.titleEn || active.dataset.title || '';
        if (titleThEl) titleThEl.textContent = active.dataset.titleTh || '';
        if (ledeEnEl) ledeEnEl.textContent = active.dataset.ledeEn || active.dataset.lede || '';
        if (ledeThEl) ledeThEl.textContent = active.dataset.ledeTh || '';
        if (bannerEl) {
          if (active.dataset.banner) {
            bannerEl.src = active.dataset.banner;
          }
          bannerEl.alt = ((active.dataset.titleEn || active.dataset.title || '') + ' / ' + (active.dataset.titleTh || '')).replace(/ \/$/, '');
        }
        var scroller = group.querySelector('[data-mb-scenario-chips]');
        var page = active.closest('.mb-scenarios__chip-page');
        var paged = Boolean(
          scroller &&
          page &&
          window.matchMedia &&
          window.matchMedia('(max-width: 849px)').matches &&
          window.getComputedStyle(page).display !== 'contents'
        );
        if (paged) {
          var left = page.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft;
          scroller.scrollTo({ left: left, behavior: reducedMotion ? 'auto' : 'smooth' });
        } else {
          try {
            active.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
          } catch (err) {}
        }
      }

      function setScenePills(value) {
        pills.filter(function (item) { return item.dataset.mirabaseFilter === 'scene'; }).forEach(function (item) {
          var active = resolveSceneValue(item.dataset.value) === value;
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
          item.classList.toggle('is-active', active);
          item.classList.toggle('is-selected', active);
        });
      }

      function sortCards(mode) {
        if (!grid || !mode || mode === 'featured') return;
        var items = Array.prototype.slice.call(grid.querySelectorAll('[data-mirabase-product-card]'));
        items.sort(function (a, b) {
          var pa = parseInt(a.dataset.price, 10) || 0;
          var pb = parseInt(b.dataset.price, 10) || 0;
          return mode === 'price-desc' ? pb - pa : pa - pb;
        });
        items.forEach(function (item) { grid.appendChild(item); });
        if (empty) grid.appendChild(empty);
      }

      function apply(options) {
        var opts = options || {};
        var visible = 0;
        cards.forEach(function (card) {
          var category = normalizeTag(card.dataset.category || 'all');
          var concern = normalizeTag(card.dataset.concern || 'all');
          var show = matchesScene(card, state.scene)
            && matchesCatalogTag(card, catalogTag)
            && (state.category === 'all' || category === normalizeTag(state.category))
            && (state.concern === 'all' || concern === normalizeTag(state.concern))
            && (!isHighlights || matchesHighlight(card, state.highlight));
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (count) {
          var template = count.dataset.countTemplate;
          if (template) count.textContent = template.replace('__COUNT__', String(visible));
          else count.textContent = visible + ' product' + (visible === 1 ? '' : 's');
        }
        if (empty) empty.hidden = visible !== 0;
        if (isScenarios) {
          setScenePills(state.scene);
          updateScenarioChrome(state.scene);
        }
        if (!opts.skipUrl) syncUrl();
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var key = pill.dataset.mirabaseFilter;
          var value = pill.dataset.value || 'all';
          if (key === 'scene') value = resolveSceneValue(value);
          state[key] = value;
          pills.filter(function (item) { return item.dataset.mirabaseFilter === key; }).forEach(function (item) {
            var itemValue = key === 'scene' ? resolveSceneValue(item.dataset.value) : (item.dataset.value || 'all');
            var active = itemValue === value;
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
            item.classList.toggle('is-active', active);
            item.classList.toggle('is-selected', active);
          });
          apply();
        });
      });

      if (isScenarios) {
        var scenePills = pills.filter(function (pill) {
          return pill.dataset.mirabaseFilter === 'scene';
        });
        var railPrev = group.querySelector('[data-mb-scenario-rail="prev"]');
        var railNext = group.querySelector('[data-mb-scenario-rail="next"]');

        function stepScene(dir) {
          if (!scenePills.length) return;
          var current = 0;
          scenePills.forEach(function (pill, i) {
            if (
              pill.classList.contains('is-active') ||
              pill.classList.contains('is-selected') ||
              pill.getAttribute('aria-pressed') === 'true'
            ) {
              current = i;
            }
          });
          var target = scenePills[(current + dir + scenePills.length) % scenePills.length];
          if (!target) return;
          state.scene = resolveSceneValue(target.dataset.value);
          apply();
        }

        if (railPrev && railPrev.dataset.mbBound !== '1') {
          railPrev.dataset.mbBound = '1';
          railPrev.classList.remove('is-disabled');
          railPrev.addEventListener('click', function (event) {
            event.preventDefault();
            stepScene(-1);
          });
        }
        if (railNext && railNext.dataset.mbBound !== '1') {
          railNext.dataset.mbBound = '1';
          railNext.classList.remove('is-disabled');
          railNext.addEventListener('click', function (event) {
            event.preventDefault();
            stepScene(1);
          });
        }
      }

      selects.forEach(function (select) {
        select.addEventListener('change', function () {
          var option = select.options[select.selectedIndex];
          var collectionUrl = option && option.getAttribute('data-collection-url');
          if (isScenarios && collectionUrl && select.dataset.mirabaseFilter === 'category' && select.value !== 'all') {
            try {
              var next = new URL(collectionUrl, window.location.href);
              if (state.scene && state.scene !== 'all') next.searchParams.set('scene', state.scene);
              window.location.assign(next.toString());
              return;
            } catch (err) {}
          }
          state[select.dataset.mirabaseFilter] = select.value;
          apply();
        });
      });

      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          state.sort = sortSelect.value || 'featured';
          sortCards(state.sort);
          apply();
        });
      }

      if (clear) {
        clear.addEventListener('click', function () {
          state.scene = isScenarios ? defaultScene : 'all';
          state.category = 'all';
          state.concern = 'all';
          state.highlight = 'all';
          state.sort = 'featured';
          setScenePills(state.scene);
          pills.filter(function (item) { return item.dataset.mirabaseFilter === 'highlight'; }).forEach(function (item) {
            var active = (item.dataset.value || 'all') === 'all';
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
            item.classList.toggle('is-active', active);
          });
          selects.forEach(function (select) {
            select.value = 'all';
            if (typeof select._mbSelectSync === 'function') select._mbSelectSync();
          });
          if (sortSelect) {
            sortSelect.value = 'featured';
            if (typeof sortSelect._mbSelectSync === 'function') sortSelect._mbSelectSync();
          }
          apply();
        });
      }

      var params = new URLSearchParams(window.location.search);
      var sceneParam = resolveSceneValue(params.get('scene') || '');
      var categoryParam = params.get('category');
      var highlightParam = params.get('highlight');
      var sortParam = params.get('sort');
      if (highlightParam) {
        state.highlight = highlightParam;
        pills.filter(function (item) { return item.dataset.mirabaseFilter === 'highlight'; }).forEach(function (item) {
          var active = (item.dataset.value || 'all') === highlightParam;
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
          item.classList.toggle('is-active', active);
        });
      }
      if (categoryParam) {
        state.category = categoryParam;
        selects.forEach(function (select) {
          if (select.dataset.mirabaseFilter === 'category') select.value = categoryParam;
        });
      }
      if (sortParam && sortSelect) {
        state.sort = sortParam;
        sortSelect.value = sortParam;
        sortCards(sortParam);
      }
      if (sceneParam && sceneParam !== 'all') {
        state.scene = sceneParam;
      }
      apply({ skipUrl: false });
    });
  }

  var MB_SELECT_MQ = '(max-width: 749px)';
  var mbSelectMenuUid = 0;
  var mbSelectMenusBound = false;

  function isMobileSelectUi() {
    return window.matchMedia && window.matchMedia(MB_SELECT_MQ).matches;
  }

  function closeMbSelectMenu(menu) {
    if (!menu) return;
    var trigger = menu.querySelector('.mb-select-menu__trigger');
    var list = menu.querySelector('.mb-select-menu__list');
    menu.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (list) {
      list.hidden = true;
      list.setAttribute('aria-hidden', 'true');
    }
  }

  function closeAllMbSelectMenus(except) {
    document.querySelectorAll('.mb-select-menu.is-open').forEach(function (menu) {
      if (except && menu === except) return;
      closeMbSelectMenu(menu);
    });
  }

  function enhanceMbSelect(select) {
    if (!select || select.dataset.mbSelectMenuReady === '1') return;
    select.dataset.mbSelectMenuReady = '1';
    if (!select.parentNode) return;

    var menu = document.createElement('div');
    menu.className = 'mb-select-menu';
    select.parentNode.insertBefore(menu, select);
    menu.appendChild(select);
    select.classList.add('mb-select-menu__native');

    mbSelectMenuUid += 1;
    var listId = 'mb-select-list-' + mbSelectMenuUid;

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'mb-select-menu__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', listId);
    if (select.getAttribute('aria-label')) {
      trigger.setAttribute('aria-label', select.getAttribute('aria-label'));
    }

    var valueEl = document.createElement('span');
    valueEl.className = 'mb-select-menu__value';
    var chevron = document.createElement('span');
    chevron.className = 'mb-select-menu__chevron';
    chevron.setAttribute('aria-hidden', 'true');
    trigger.appendChild(valueEl);
    trigger.appendChild(chevron);

    var list = document.createElement('ul');
    list.className = 'mb-select-menu__list';
    list.id = listId;
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    list.setAttribute('aria-hidden', 'true');

    Array.prototype.forEach.call(select.options, function (opt) {
      var item = document.createElement('li');
      item.className = 'mb-select-menu__option';
      item.setAttribute('role', 'option');
      item.tabIndex = -1;
      item.dataset.value = opt.value;
      item.textContent = opt.textContent;
      list.appendChild(item);
    });

    menu.appendChild(trigger);
    menu.appendChild(list);

    function syncMenu() {
      var current = select.options[select.selectedIndex];
      valueEl.textContent = current ? current.textContent : '';
      var isDefault = select.value === 'all' || select.value === 'featured' || select.value === '';
      trigger.classList.toggle('is-active', !isDefault);
      Array.prototype.forEach.call(list.children, function (item) {
        var selected = item.dataset.value === select.value;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    }

    function applyMode() {
      var mobile = isMobileSelectUi();
      select.tabIndex = mobile ? -1 : 0;
      if (mobile) select.setAttribute('aria-hidden', 'true');
      else {
        select.removeAttribute('aria-hidden');
        closeMbSelectMenu(menu);
      }
    }

    function openMenu() {
      if (!isMobileSelectUi()) return;
      closeAllMbSelectMenus(menu);
      list.hidden = false;
      list.setAttribute('aria-hidden', 'false');
      menu.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    select._mbSelectSync = syncMenu;

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (!isMobileSelectUi()) return;
      if (menu.classList.contains('is-open')) closeMbSelectMenu(menu);
      else openMenu();
    });

    list.addEventListener('click', function (event) {
      var item = event.target.closest('.mb-select-menu__option');
      if (!item) return;
      event.preventDefault();
      event.stopPropagation();
      var next = item.dataset.value;
      if (select.value !== next) {
        select.value = next;
        var change = document.createEvent('HTMLEvents');
        change.initEvent('change', true, false);
        select.dispatchEvent(change);
      } else {
        syncMenu();
      }
      closeMbSelectMenu(menu);
      try { trigger.focus(); } catch (err) {}
    });

    select.addEventListener('change', syncMenu);

    syncMenu();
    applyMode();

    if (window.matchMedia) {
      var mq = window.matchMedia(MB_SELECT_MQ);
      var onMq = function () { applyMode(); };
      if (mq.addEventListener) mq.addEventListener('change', onMq);
      else if (mq.addListener) mq.addListener(onMq);
    }
  }

  function initCustomSelectMenus(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.mirabase-filter-select').forEach(function (select) {
      enhanceMbSelect(select);
      if (typeof select._mbSelectSync === 'function') select._mbSelectSync();
    });
    if (mbSelectMenusBound) return;
    mbSelectMenusBound = true;
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('.mb-select-menu')) return;
      closeAllMbSelectMenus();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.key === 'Esc') closeAllMbSelectMenus();
    });
  }

  function initAccordions() {
    document.querySelectorAll('.mirabase-product__details details, .mb-pdp-accordions details').forEach(function (detail) {
      detail.addEventListener('toggle', function () {
        if (!detail.open) return;
        var parent = detail.parentElement;
        if (!parent) return;
        parent.querySelectorAll('details[open]').forEach(function (openDetail) {
          if (openDetail !== detail) openDetail.open = false;
        });
      });
    });
  }

  function initNavDropdown() {
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-mb-nav-dropdown]'));
    if (!items.length) return;

    function closeAll(except) {
      items.forEach(function (item) {
        if (except && item === except) return;
        item.classList.remove('is-open');
        var trigger = item.querySelector('[data-mb-nav-dropdown-trigger]');
        var panel = item.querySelector('[data-mb-nav-dropdown-panel]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      });
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-mb-nav-dropdown-trigger]');
      var panel = item.querySelector('[data-mb-nav-dropdown-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function (event) {
        var open = item.classList.contains('is-open');
        if (finePointer && !item.closest('.mb-mobile-menu')) {
          /* Desktop: allow navigation to product hub; keep hover/focus for menu */
          return;
        }
        event.preventDefault();
        if (open) {
          closeAll();
          return;
        }
        closeAll(item);
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      });

      if (finePointer) {
        item.addEventListener('mouseenter', function () {
          if (item.closest('.mb-mobile-menu')) return;
          closeAll(item);
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        });
        item.addEventListener('mouseleave', function () {
          if (item.closest('.mb-mobile-menu')) return;
          closeAll();
        });
      }
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-mb-nav-dropdown]')) return;
      closeAll();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });
  }

  function initGalleryReveal() {
    document.querySelectorAll('[data-mirabase-main-media]').forEach(function (main) {
      var img = main.querySelector('img');
      if (!img) return;
      img.addEventListener('load', function () {
        img.classList.add('is-loaded');
      }, { once: true });
      if (img.complete) img.classList.add('is-loaded');
    });
  }

  function updateMirabaseCartCount(count) {
    var link = document.querySelector('#cart-icon-bubble[data-mb-cart-count]');
    if (!link) return;
    var badge = link.querySelector('.mb-cart-count');
    var next = parseInt(count, 10);
    if (Number.isNaN(next)) next = 0;
    if (next > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'mb-cart-count';
        link.appendChild(badge);
      }
      badge.textContent = String(next);
    } else if (badge) {
      badge.remove();
    }
  }

  window.mirabaseUpdateCartCount = updateMirabaseCartCount;

  function initCartFeedback() {
    if (document.documentElement.dataset.mbCartFeedbackReady === '1') return;
    document.documentElement.dataset.mbCartFeedbackReady = '1';

    document.addEventListener('mirabase:cart-added', function () {
      var bubble = document.querySelector('[data-mb-cart-count], #cart-icon-bubble');
      if (!bubble) return;
      bubble.classList.add('is-cart-pulse');
      animate(bubble, [{ transform: 'scale(1)' }, { transform: 'scale(1.08)' }, { transform: 'scale(1)' }], { duration: 280, easing: 'ease-out' });
      window.setTimeout(function () { bubble.classList.remove('is-cart-pulse'); }, 320);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var cart = event && event.cartData;
        if (!cart || typeof cart.item_count !== 'number') return;
        updateMirabaseCartCount(cart.item_count);
      });
    }
  }

  function initTrustTabs() {
    document.querySelectorAll('[data-mirabase-tabs]').forEach(function (group) {
      var tabs = Array.prototype.slice.call(group.querySelectorAll('[data-tab-target], [data-mirabase-trust-tab]'));
      var panels = Array.prototype.slice.call(group.querySelectorAll('[role="tabpanel"], [data-mirabase-trust-panel]'));
      if (!tabs.length || !panels.length) return;

      function activate(targetId) {
        tabs.forEach(function (tab) {
          var id = tab.dataset.tabTarget || tab.dataset.mirabaseTrustTab;
          var active = id === targetId;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var id = panel.id || panel.dataset.mirabaseTrustPanel;
          var show = id === targetId;
          panel.hidden = !show;
          panel.classList.toggle('is-active', show);
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab.dataset.tabTarget || tab.dataset.mirabaseTrustTab);
        });
      });
    });
  }

  function initHeaderHover() {
    if (!finePointer) return;
    document.querySelectorAll('.mb-header__nav .mb-menu-link').forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        link.style.transition = 'color 160ms ease, transform 160ms ease';
      });
    });
  }

  function initChannelsMapLink() {
    document.querySelectorAll('[data-mb-channel-item]').forEach(function (item) {
      item.addEventListener('click', function () {
        var mapFrame = document.querySelector('[data-mb-channels-map] iframe');
        var lat = item.dataset.lat;
        var lng = item.dataset.lng;
        if (!mapFrame || !lat || !lng) return;
        mapFrame.src = 'https://maps.google.com/maps?q=' + encodeURIComponent(lat + ',' + lng) + '&z=15&output=embed';
        document.querySelectorAll('[data-mb-channel-item].is-active').forEach(function (el) {
          el.classList.remove('is-active');
        });
        item.classList.add('is-active');
      });
    });
  }

  function normalizeTag(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function initDiscoverDock(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var docks = Array.prototype.slice.call(scope.querySelectorAll('[data-mb-discover-dock]'));
    if (!docks.length && scope.matches && scope.matches('[data-mb-discover-dock]')) {
      docks = [scope];
    }

    docks.forEach(function (dock) {
      if (dock.dataset.mbDiscoverReady === '1') return;
      dock.dataset.mbDiscoverReady = '1';

      var track = dock.querySelector('[data-mb-discover-track]');
      var prev = dock.querySelector('[data-mb-discover-prev]');
      var next = dock.querySelector('[data-mb-discover-next]');
      var chips = Array.prototype.slice.call(dock.querySelectorAll('[data-mb-scene-chip]'));
      var defaultScene = normalizeTag(dock.dataset.mbSceneDefault || 'dawn');

      // Explicit visual button → product tag map
      // Dawn UI uses tag "down" per merchant product data (do not rename product tags).
      var sceneTagMap = {
        dawn: 'dawn',
        down: 'dawn',
        sun: 'sun',
        dusk: 'dusk',
        moon: 'moon',
        bts: 'bts',
        date: 'date',
        beach: 'beach',
        holiday: 'holiday',
        mountain: 'mountain',
        showerspa: 'shower',
        'shower-spa': 'shower',
        shower: 'shower',
        spa: 'shower'
      };

      var sceneAliases = {
        dawn: ['down', 'dawn', 'morning'],
        down: ['down', 'dawn', 'morning'],
        sun: ['sun', 'noon', 'midday'],
        dusk: ['dusk', 'evening'],
        moon: ['moon', 'night'],
        bts: ['bts'],
        date: ['date'],
        beach: ['beach'],
        holiday: ['holiday'],
        mountain: ['mountain'],
        shower: ['shower', 'shower-spa', 'spa', 'shower_spa'],
        'shower-spa': ['shower', 'shower-spa', 'spa', 'shower_spa']
      };

      function resolveSceneKey(raw) {
        var key = normalizeTag(raw).replace(/[\s_]+/g, '-');
        if (sceneTagMap[key]) return sceneTagMap[key];
        if (sceneTagMap[key.replace(/-/g, '')]) return sceneTagMap[key.replace(/-/g, '')];
        return key || defaultScene;
      }

      function cardTokens(card) {
        var tokens = String(card.dataset.tags || '')
          .split(',')
          .map(normalizeTag)
          .filter(Boolean);
        var scene = normalizeTag(card.dataset.scene);
        if (scene) tokens.push(scene);
        return tokens;
      }

      function cardMatchesScene(card, sceneKey) {
        var aliases = sceneAliases[sceneKey] || [sceneKey];
        var tokens = cardTokens(card);
        var knownScene = ['down', 'dawn', 'sun', 'dusk', 'moon', 'bts', 'date', 'beach', 'holiday', 'mountain', 'shower', 'shower-spa', 'spa'];
        var tagged = tokens.some(function (token) {
          return knownScene.indexOf(token) !== -1;
        });
        // Untagged products stay visible until a scene tag exists. Tagged products use exact token match.
        if (!tagged) return true;
        return aliases.some(function (alias) {
          var needle = normalizeTag(alias);
          return tokens.indexOf(needle) !== -1;
        });
      }

      function productRoots() {
        return Array.prototype.slice.call(document.querySelectorAll('[data-mb-scene-products]'));
      }

      function setSelected(sceneKey) {
        chips.forEach(function (chip) {
          var active = resolveSceneKey(chip.dataset.sceneKey) === sceneKey;
          chip.classList.toggle('is-selected', active);
          chip.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      function filterProducts(sceneKey) {
        productRoots().forEach(function (root) {
          var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mirabase-product-card]'));
          var empty = root.querySelector('[data-mb-scene-empty]');
          var explore = root.querySelector('[data-mb-scene-explore]');
          var visible = 0;
          cards.forEach(function (card) {
            var show = cardMatchesScene(card, sceneKey);
            card.hidden = !show;
            if (show) visible += 1;
          });
          if (empty) empty.hidden = visible !== 0;
          if (explore) {
            var activeChip = chips.filter(function (chip) {
              return resolveSceneKey(chip.dataset.sceneKey) === sceneKey;
            })[0];
            if (activeChip && activeChip.dataset.sceneHref) {
              explore.setAttribute('href', activeChip.dataset.sceneHref);
            }
          }
        });
      }

      function applyScene(rawKey) {
        var sceneKey = resolveSceneKey(rawKey);
        setSelected(sceneKey);
        filterProducts(sceneKey);
        if (typeof window.mbHomeSceneUpdate === 'function') {
          window.mbHomeSceneUpdate(sceneKey);
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('scene', sceneKey);
          window.history.replaceState({}, '', url);
        } catch (err) {}
      }

      function revealChip(chip) {
        if (!chip || !track) return;
        var chipRect = chip.getBoundingClientRect();
        var trackRect = track.getBoundingClientRect();
        var left = track.scrollLeft + (chipRect.left - trackRect.left) - Math.max(0, (track.clientWidth - chip.offsetWidth) / 2);
        var top = track.scrollTop + (chipRect.top - trackRect.top) - Math.max(0, (track.clientHeight - chip.offsetHeight) / 2);
        try {
          track.scrollTo({
            left: Math.max(0, left),
            top: Math.max(0, top),
            behavior: reducedMotion ? 'auto' : 'smooth'
          });
        } catch (err) {
          track.scrollLeft = Math.max(0, left);
          track.scrollTop = Math.max(0, top);
        }
      }

      function stepScene(dir) {
        if (!chips.length) return;
        var current = 0;
        chips.forEach(function (chip, i) {
          if (chip.classList.contains('is-selected') || chip.getAttribute('aria-pressed') === 'true') {
            current = i;
          }
        });
        var target = chips[(current + dir + chips.length) % chips.length];
        if (!target) return;
        applyScene(target.dataset.sceneKey);
        revealChip(target);
      }

      if (prev && chips.length && prev.dataset.mbBound !== '1') {
        prev.dataset.mbBound = '1';
        prev.addEventListener('click', function () {
          stepScene(-1);
        });
      }

      if (next && chips.length && next.dataset.mbBound !== '1') {
        next.dataset.mbBound = '1';
        next.addEventListener('click', function () {
          stepScene(1);
        });
      }

      chips.forEach(function (chip) {
        if (chip.dataset.mbBound === '1') return;
        chip.dataset.mbBound = '1';
        chip.addEventListener('click', function (event) {
          var href = chip.getAttribute('href') || '';
          if (chip.tagName === 'A' && href) {
            try {
              var target = new URL(href, window.location.href);
              if (target.pathname !== window.location.pathname) {
                return;
              }
              event.preventDefault();
            } catch (err) {}
          } else {
            event.preventDefault();
          }
          applyScene(chip.dataset.sceneKey);
        });
      });

      var paramScene = '';
      try {
        paramScene = new URLSearchParams(window.location.search).get('scene') || '';
      } catch (err) {}
      var initial = resolveSceneKey(paramScene || defaultScene);
      var hasInitial = chips.some(function (chip) {
        return resolveSceneKey(chip.dataset.sceneKey) === initial;
      });
      applyScene(hasInitial ? initial : defaultScene);
    });
  }

  function initFormValidation() {
    if (document.documentElement.dataset.mbFormValidationBound === '1') return;
    document.documentElement.dataset.mbFormValidationBound = '1';

    function fill(template, value) {
      return String(template || '').replace(/\{\{\s*value\s*\}\}/g, value);
    }

    function applyMessage(input) {
      if (!input || typeof input.setCustomValidity !== 'function') return;
      input.setCustomValidity('');
      if (input.validity.valid) return;

      var msgs = window.mbFormValidation || {};
      var val = input.value || '';
      var type = (input.getAttribute('type') || input.type || '').toLowerCase();

      if (input.validity.valueMissing) {
        input.setCustomValidity(
          type === 'email' ? (msgs.emailRequired || msgs.required || '') : (msgs.required || '')
        );
        return;
      }

      if (type === 'email' && input.validity.typeMismatch) {
        if (val.indexOf('@') === -1) {
          input.setCustomValidity(fill(msgs.emailMissingAt, val));
        } else if (!val.split('@')[1]) {
          input.setCustomValidity(fill(msgs.emailMissingDomain, val));
        } else {
          input.setCustomValidity(msgs.emailInvalid || '');
        }
      }
    }

    document.addEventListener(
      'invalid',
      function (event) {
        applyMessage(event.target);
      },
      true
    );

    document.addEventListener(
      'input',
      function (event) {
        var target = event.target;
        if (!target || typeof target.setCustomValidity !== 'function') return;
        target.setCustomValidity('');
      },
      true
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initPressFeedback();
    initFilterPills();
    initCustomSelectMenus();
    initAccordions();
    initNavDropdown();
    initGalleryReveal();
    initCartFeedback();
    initTrustTabs();
    initHeaderHover();
    initChannelsMapLink();
    initDiscoverDock(document);
    initFormValidation();
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event && event.target ? event.target : document;
    section.querySelectorAll('[data-mb-discover-dock]').forEach(function (dock) {
      delete dock.dataset.mbDiscoverReady;
      dock.querySelectorAll('[data-mb-scene-chip], [data-mb-discover-prev], [data-mb-discover-next]').forEach(function (el) {
        delete el.dataset.mbBound;
      });
    });
    section.querySelectorAll('[data-mirabase-filter-group]').forEach(function (group) {
      delete group.dataset.mbFilterReady;
      group.querySelectorAll('[data-mb-scenario-rail]').forEach(function (el) {
        delete el.dataset.mbBound;
      });
    });
    initDiscoverDock(section);
    initFilterPills(section);
    initCustomSelectMenus(section);
  });

  window.addEventListener('popstate', function () {
    document.querySelectorAll('[data-mirabase-filter-group]').forEach(function (group) {
      delete group.dataset.mbFilterReady;
    });
    initFilterPills(document);
    initCustomSelectMenus(document);
  });
}());
